<template>
  <v-app>
    <v-main class="unauth-main">
      <v-theme-provider root>
        <v-container class="pa-0 fill-height" fluid>
          <v-row
            class="fill-height ma-0"
            :class="rowClass"
          >
            <v-col
              :cols="12"
              :md="6"
              :lg="4"
              class="pa-0"
            >
              <div :class="contentPaddingClass">
                <v-slide-x-transition v-if="!isMobile" mode="out-in">
                  <router-view />
                </v-slide-x-transition>

                <v-slide-y-transition v-else mode="out-in">
                  <router-view />
                </v-slide-y-transition>

                <div class="mt-10 text-center">
                  <a href="https://hk-dreams.com/" target="_blank">
                    <img
                      alt="powered-by-img"
                      :height="logoHeight"
                      :src="poweredByLogo"
                    />
                  </a>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-theme-provider>
    </v-main>

    <SnackBar />
  </v-app>
</template>

<script>
export default {
  components: {
    SnackBar: () => import("@/components/utils/ErrorHandler.vue")
  },
  data() {
    return {
      poweredByLogo: this.$appConfig.assets.img.custom.poweredBy
    }
  },
  computed: {
    isMobile() {
      // Vuetify est prioritaire, sinon fallback CSS media query
      return (this.$vuetify?.breakpoint?.smAndDown) ||
             (typeof window !== 'undefined' && window.matchMedia?.('(max-width: 960px)').matches)
    },
    rowClass() {
      // On aligne en haut sur mobile pour éviter les soucis avec le clavier
      return this.isMobile
        ? "justify-center align-start bg-mobile pt-8 pb-6"
        : "justify-center align-center bg-desktop"
    },
    contentPaddingClass() {
      return this.isMobile ? "content-wrapper px-6" : "content-wrapper px-10"
    },
    logoHeight() {
      return this.isMobile ? 24 : 30
    }
  }
}
</script>

<style scoped lang="scss">
/* Neutraliser les styles globaux de mobile-styles.css qui ajoutent du padding asymétrique */
.unauth-main {
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 0 !important;
}

.unauth-main::v-deep .container--fluid {
  padding: 0 !important;
}

.content-wrapper {
  width: 100%;
}

/* Arrière-plan desktop (image de couverture) */
.bg-desktop {
  background-size: cover;
  background-position: 70% 30%;
  //background-image: url(../../assets/img/common/cover.jpg);
}

/* Arrière-plan mobile (plus léger) */
/*.bg-mobile {
  background: linear-gradient(180deg, #f7f7fb 0%, #ffffff 100%);
}*/

/* Optionnel : évite une hauteur trop tassée en paysage mobile */
@media (max-height: 600px) and (max-width: 960px) {
  .bg-mobile {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
}
</style>
